import { render, staticRenderFns } from "./DealStatus.vue?vue&type=template&id=b68b01ca&scoped=true"
import script from "./DealStatus.vue?vue&type=script&lang=js"
export * from "./DealStatus.vue?vue&type=script&lang=js"
import style0 from "./DealStatus.vue?vue&type=style&index=0&id=b68b01ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68b01ca",
  null
  
)

export default component.exports